(function ($) {
  $(document).ready(function () {
    const crossSellCheckboxClass = 'js-add-to-cart-crossell';
    const crossSellCheckbox = $('.' + crossSellCheckboxClass);

    if (crossSellCheckbox.length) {
      $(document).on('change', '.' + crossSellCheckboxClass, function () {
        const productId = $(this).data('product-id');
        const parentCartItemKey = $(this).data('parent-key');
        const productQuantity =
          $(this).parents('tr').find('.js-quantity-input').val() || 1;

        if ($(this).is(':checked')) {
          // Add to cart
          const data = {
            action: 'wc_crossell_ajax_add_to_cart',
            product_id: productId,
            quantity: productQuantity,
            parent_cart_item_key: parentCartItemKey,
          };

          $.ajax({
            type: 'post',
            url: woocommerce_params.ajax_url,
            data: data,
            success: function (response) {
              if (response.error) {
                console.log('error');
              }

              $('.js-update-cart').removeAttr('disabled').trigger('click');
            },
          });
        } else {
          // Remove from cart
          $(this).parents('tr').find('.js-remove-product').trigger('click');
        }
      });
    }
  });
})(jQuery);
